<template>
  <v-container
    fill-height
    fluid
  >
    <v-row justify="center">

        <material-card
          :title="$t('workOperations.edit.title')"
          :text="$t('workOperations.edit.text')"

        >

          <v-form @submit.prevent="editWorkOperation">
            <v-container >
              <v-row>
                <v-col
                  cols="12"
                  md="6"
                >
                  <v-text-field
                    v-model="workOperationName"
                    :label="$t('workOperation.name')"
                    :error-messages="nameErrors"
                    required
                    @input="$v.workOperationName.$touch()"
                    @blur="$v.workOperationName.$touch()"

                  />
                </v-col>



                <v-col
                  cols="12"
                  class="text-right"
                >
                  <v-btn   @click.prevent="historyBack">
                    {{$t("global.cancel")}}
                  </v-btn>&nbsp;
                  <v-btn @click="submit" color="success">
                    {{$t("global.save")}}
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </material-card>

    </v-row>
  </v-container>
</template>

<script>

    import api from '../components/backend/backend-api'
    import { required } from 'vuelidate/lib/validators'


    export default {
        data() {
            return {
                workOperationName: "",
                workTypeId: "",
              workOperations: []


            }
        },
        validations: {
            workOperationName: {
                required,
              isUnique(value) {
                if (value === '') return true
                let currentId =this.id
                let existingWorkOperations = this.workOperations.filter(function (ele) {
                  return ele.name ==value && ele.id != currentId
                })
                return existingWorkOperations.length == 0
              }

            }
        },
        methods: {
            submit () {
                this.$v.$touch()
                if (!this.$v.$invalid) {
                    this.editWorkOperation()
                }
            },
            getWorkOperation(workOperationid) {

                api.getWorkOperation(workOperationid).then(response => {
                    this.id = response.id
                    this.workOperationName= response.name
                    this.workTypeId = response.workTypeId
                  this.getWorkOperations ()
                })
                    .catch(error => {
                         this.$store.commit('setErrorMsg', error)
                        console.log(error)
                        //    this.errors.push(error)
                    })
            },
          getWorkOperations () {
            api.getWorkOperations(this.workTypeId).then(response => {
              this.workOperations = response
            })
              .catch(error => {
                this.$store.commit('setErrorMsg', error)
                console.log(error)
                //    this.errors.push(error)
              })
          },
            editWorkOperation() {
                api.editWorkOperation(this.id, this.workOperationName).then(response => {
                    this.$router.push({path: '/workTypeShow/' + this.workTypeId});

                    //   console.log(response.data)
                })
                    .catch(error => {
                         this.$store.commit('setErrorMsg', error)
                        console.log(error)
                        //    this.errors.push(error)
                    })


            }

        },
        computed: {
            nameErrors () {
                const errors = []
                if (!this.$v.workOperationName.$dirty) return errors
                !this.$v.workOperationName.required && errors.push(this.$t('validation.required', [this.$t('workOperation.name')]))
              !this.$v.workOperationName.isUnique && errors.push(this.$t('validation.unique', [this.$t('workOperation.name')]))

              return errors
            }
        },
        mounted() {
           this.getWorkOperation(this.$route.params.id)
        }
    }
</script>
